angular.module('unergie.main')
.directive('userInfoAccountEnergyCheck', ($uibModal, $filter, AlertManager, BoFeaturesService, ModalService, PaymentService, MetaWatcher, ContractService, ErrorCatcher) =>
    ({
        restrict: 'E',
        templateUrl: '/states/userContractInfo/component/account/userInfoAccountEnergyCheck.html',
        link($scope) {
            $scope.selectedContract = null
            $scope.spinners = {}

            $scope.openEnergyCheckModal = () => ModalService.openModal({ type: 'energyCheckModal', size: 'lg' }, { account: $scope.account }, $scope.refreshAccount)

            $scope.openEnergyCheckHistoryModal = () => ModalService.openModal({ type: 'energyCheckHistoryModal', size: 'lg' }, { account: $scope.account })

            $scope.canBurnEnergyCheck = () => PaymentService.canBurnEnergyCheck($scope.selectedContract, $scope.account)

            $scope.energyCheckBurnPayload = PaymentService.energyCheckBurnPayload()
            $scope.energyCheckBurnFields = PaymentService.energyCheckBurnFields()

            $scope.energyCheckBurn = () =>
                PaymentService.energyCheckBurn($scope.selectedContract, $scope.account, $scope.energyCheckBurnPayload, $scope.spinners).then(() => MetaWatcher.notif('ACCOUNT_CHANGED'))


            const computeEnergyChecks = () => {
                $scope.nbChecks = _.countBy($scope.account.energyChecks, (check) => check.status === 'VALIDATED').true || 0
                $scope.hasValidCheck = _.some($scope.account.energyChecks, (check) => check.status === 'VALIDATED' && moment(check.validity_date).isAfter(moment()))
                $scope.hadValidCheck = _.some($scope.account.energyChecks, (check) => check.status === 'VALIDATED')
                $scope.checkTitle = `Dispose d'un chèque valide`
                if (!$scope.hasValidCheck) {
                    if (!$scope.hadValidCheck) {
                        $scope.checkTitle = 'Ne dispose pas de chèque valide'
                    } else {
                        $scope.checkTitle = 'Ne dispose plus de chèque valide'
                    }
                }
            }

            $scope.getEnergyChecks = () => {
                if ($scope.account.energyChecks && $scope.account.energyChecks.length) {
                    const last = _.orderBy($scope.account.energyChecks, 'validity_date').pop()
                    return `Dispose d'${last.type === 'CHECK' ? 'un chèque énergie' : 'une attestation'} ${last.status === 'VALIDATED' ? 'valide' : 'en attente de validation'}` +
                    ` (fin de validité ${moment(last.validity_date).format('DD/MM/YYYY')})`
                }
                return null
            }

            computeEnergyChecks()

            $scope.$watch('account', computeEnergyChecks)

            ContractService.watch('userInfoAccountEnergyCheck', (selectedContract) => {
                $scope.selectedContract = selectedContract
            })
        },
    })
)
